var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.8 5.546c.406 0 .744.3.794.691l.006.1v6.252h.8V7.902c0-.405.307-.736.7-.785l.1-.006h1.6c.406 0 .744.3.794.692l.006.1v4.686h.4a.4.4 0 0 1 .08.792l-.08.008H1a.4.4 0 0 1-.08-.792L1 12.59h.4V10.25c0-.405.307-.737.7-.785l.1-.006h1.6c.406 0 .744.3.794.691l.006.1v2.339h.8V6.337c0-.405.307-.737.7-.785l.1-.006h1.6zm-4.001 4.712H2.2l-.001 2.331h1.6v-2.331zM7.8 6.346H6.2v6.243h1.6V6.346zm3.999 1.564H10.2l-.001 4.679h1.6V7.91zM13.004.85a.4.4 0 0 1 .15.031l.061.032a.402.402 0 0 1 .07.057l.022.023.014.018.005.008-.008-.009.011.014.03.049a.408.408 0 0 1 .04.138l.001.039v2.348a.4.4 0 0 1-.792.08l-.008-.08-.001-1.398-2.013 1.97c-.378.37-.915.528-1.422.432l-.152-.036-3.044-.796a.822.822 0 0 0-.698.134l-.08.069-3.11 3.043a.4.4 0 0 1-.612-.51l.052-.062L4.63 3.4a1.618 1.618 0 0 1 1.39-.437l.15.032 3.056.8a.821.821 0 0 0 .718-.127l.083-.07 1.991-1.949H10.6a.4.4 0 0 1-.392-.32l-.008-.08a.4.4 0 0 1 .32-.392L10.6.85h2.404z",
    fillRule: "nonzero"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/report.07f04a81.svg";
export { ForwardRef as ReactComponent };